let dialogRef: HTMLDialogElement;

export interface IDialogButton {
  [key: string]: {
    label: string,
    icon?: string,
    styles?: string,
    onClick: Function
  }
}

export interface IDialogOptions {
  buttons?: IDialogButton,
  size?: 'sm' | 'md' | 'lg' | 'huge',
  dismissable?: boolean,
  data?: any,
}

export const createDialog = (title: string, content: string, options: IDialogOptions
  ) => {

  return generateDialog(title, content, options);
}

const generateDialog = (title: string, content: string, options: IDialogOptions) => {
  dialogRef = document.createElement('dialog');
  dialogRef.classList.add('dialog');
  dialogRef.classList.add(options.size || 'md');

  // Allow click outside?
  if (options.dismissable) {
    dialogRef.addEventListener('click', (evt) => {
      if (evt.target === dialogRef) {
        dialogRef.close();
      }
    });
  }

  document.body.appendChild(dialogRef);

  dialogRef.innerHTML = `
    <div class="title">${title}</div>
    <div class="content">${content}</div>
    ${options.buttons ? generateButtons(options.buttons) : ''}
  `;

  const dialogButtons = dialogRef.querySelectorAll('.button');

  dialogButtons.forEach((dialogButton: HTMLUiButtonElement) => {
    dialogButton.addEventListener('clicked', () => {
      const dialogContentComponent = dialogRef.querySelector('.content > *');
      const data = {};

      if (dialogContentComponent && options.data) {
        Object.keys(options.data).forEach((key: string) => {
          data[key] = dialogContentComponent[key];
        });
      }

      options.buttons[dialogButton.id].onClick(data);
    });
  });

  if (options.data) {
    const dialogContentComponent = dialogRef.querySelector('.content > *');
    Object.keys(options.data).forEach((key: string) => {
      dialogContentComponent[key] = options.data[key];
    });
  }

  dialogRef.showModal();
  return dialogRef;
}

const generateButtons = (buttons: IDialogButton) => {
  return `<div class="buttons">
    ${Object.keys(buttons).map((key: string) => {
      let button = `<ui-button `;
      button += buttons[key].styles ? `styles="${buttons[key].styles}" ` : '';
      button += `class="button" `;
      button += `id="${key}" `;
      button += `content="${buttons[key].label}" `;
      button += buttons[key].icon ? `icon="${buttons[key].icon}" ` : '';
      button += `></ui-button>`;

      return button;
    }).join('')}
  </div>`;
}